var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"shipment-item-proposals-item-status pl-3 pb-3"},[_vm._v(" "+_vm._s(_vm.$t('shipment.values.proposal_statuses.' + _vm.proposal.status))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }